import { render, staticRenderFns } from "./ServiceproviderAccount.vue?vue&type=template&id=15745144&"
import script from "./ServiceproviderAccount.vue?vue&type=script&lang=js&"
export * from "./ServiceproviderAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports